import _defineProperty from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/renato/github/renato145.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { array } from 'vega-util';
import { isConditionalDef, isConditionalParameter } from '../../../channeldef';
import { expression } from '../../predicate';
import { parseSelectionPredicate } from '../../selection/parse';
/**
 * Return a mixin that includes a Vega production rule for a Vega-Lite conditional channel definition
 * or a simple mixin if channel def has no condition.
 */

export function wrapCondition(model, channelDef, vgChannel, refFn) {
  var condition = isConditionalDef(channelDef) && channelDef.condition;
  var valueRef = refFn(channelDef);

  if (condition) {
    var conditions = array(condition);
    var vgConditions = conditions.map(function (c) {
      var conditionValueRef = refFn(c);

      if (isConditionalParameter(c)) {
        var param = c.param,
            empty = c.empty;
        var test = parseSelectionPredicate(model, {
          param: param,
          empty: empty
        });
        return Object.assign({
          test: test
        }, conditionValueRef);
      } else {
        var _test = expression(model, c.test); // FIXME: remove casting once TS is no longer dumb about it


        return Object.assign({
          test: _test
        }, conditionValueRef);
      }
    });
    return _defineProperty({}, vgChannel, [].concat(_toConsumableArray(vgConditions), _toConsumableArray(valueRef !== undefined ? [valueRef] : [])));
  } else {
    return valueRef !== undefined ? _defineProperty({}, vgChannel, valueRef) : {};
  }
}